import React from 'react';

const CartCount = ({ quantity }) => quantity;

export default CartCount;
